<template>
  <section id="landing-last">
    <div class="flex">
      <h5>Wynajmij adres dla firmy już dzisiaj!</h5>
      <router-link to="/pakiety" class="default">Wybierz pakiet</router-link>
    </div>
    <div class="img"></div>
  </section>
</template>

<script>
export default {
  name: 'LandingLast',
}
</script>

<style scoped lang="scss">
  section#landing-last { height: 371px; position: relative; }
  div.flex { display: flex; flex-direction: column; justify-content: center; align-items: center; position: absolute; left: 50%; z-index: 2; }
  h5 { margin: 0 0 30px 0; padding: 20px 50px; background: $grayLight; color: #fff; font-size: 24px; font-weight: 500; }
  div.img { width: 100%; height: 350px; position: absolute; bottom: 0; z-index: 1; background: url('../assets/banner_bottom.webp') no-repeat 50% 50%; background-size: 100% 100%;  }

  @media (max-width: 1100px) {
    div.flex { width: 100vw; left: 0; }
    h5 { margin: 0 auto 30px auto; }
  }

  @media (max-width: 700px) {
    h5 { padding: 10px 30px; font-size: 18px; text-align: center; }
    section#landing-last { height: 175px; }
    div.img { display: none; }
  }

  @media (max-width: 400px) {
    h5 { width: calc(100vw - 40px); }
  }
</style>
